import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import StudentsPage from '../Admin/StudentsPage'
import TeachersPage from '../Admin/TeachersPage'
import Applications from '../Admin/Applications'
import AccountDocs from '../Admin/AccountDocs'
import { auth } from './../../store/auth'
import { observer } from 'mobx-react-lite'
import { appName } from '../../Service/http'
import ApplicationsTeacher from '../Admin/ApplicationsTeacher'
import Directory from '../Admin/Directory'
import Accepter from '../Admin/Accepter'
import Reports from '../Admin/Reports'
export default observer(function AdminIndexPage() {
	return (
		<div className='LayoutPage'>
			<Routes>
				<Route path={`/${appName}`} element={<StudentsPage />} />
				<Route path={`/${appName}/students`} element={<StudentsPage />} />
				<Route path={`/${appName}/teachers`} element={<TeachersPage />} />
				<Route path={`/${appName}/directory`} element={<Directory />} />
				<Route path={`/${appName}/accepter`} element={<Accepter />} />
				<Route path={`/${appName}/reports`} element={<Reports />} />
				{auth.user.data.AVN_BT_report === 1 && (
					<>
						<Route path={`/${appName}/applications`} element={<Applications />} />
						<Route path={`/${appName}/applicationsTeacher`} element={<ApplicationsTeacher />} />
						<Route path={`/${appName}/registration`} element={<AccountDocs />} />
					</>
				)}
			</Routes>
			<Outlet />
		</div>
	)
})
